<template>
	<b-modal
		header-class="header-class-modal-doc-package"
		:title="title"
		v-model="isOpen"
		size="md"
		centered
		no-close-on-backdrop
		no-close-on-esc
		hide-header-close
		@shown="focusedOnComment"
	>
		<div :class="$screen.width > 576 ? 'container-layout' : 'container-mobile'">
			<b-row>
				<b-col>
					<!-- <pre>{{ expenseItemId }}</pre> -->
					<b-form-group :label="FormMSG(2, 'Enter your comment')">
						<b-form-textarea
							ref="comment"
							v-model="comment"
							autocomplete="off"
							rows="3"
							:class="{
								'is-invalid': $v.comment.$error
							}"
						/>
						<div v-if="$v.comment.$error" class="invalid-feedback">
							{{ FormMSG(5, 'Please, comment is required') }}
						</div>
					</b-form-group>
				</b-col>
			</b-row>
		</div>
		<template #modal-footer>
			<div class="w-100 d-flex flex-row justify-content-end align-items-center">
				<b-button size="sm" variant="custom-outline-gray" class="w-138-px" :disabled="watingSubmitForm" @click="emitEventClose" block>
					{{ FormMSG(3, 'Close') }}
				</b-button>
				<b-button
					size="sm"
					variant="custom-primary-blue"
					class="w-138-px ml-2"
					:disabled="watingSubmitForm || $v.$invalid"
					style="margin-top: -1px"
					@click="save"
					block
				>
					<div class="d-flex justify-content-center align-items-center">
						<b-spinner v-show="watingSubmitForm" small />
						<div class="pl-2" style="margin-top: 1px">{{ FormMSG(4, 'Save') }}</div>
					</div>
				</b-button>
			</div>
		</template>
	</b-modal>
</template>
<script>
import LanguageMessages from '@/mixins/languageMessages';
import GlobalMixin from '@/mixins/global.mixin';
import { validationMixin } from 'vuelidate';
import { required, minLength } from 'vuelidate/lib/validators';
import { rejectExpenseItem, rejectExpense } from '@/cruds/expense.crud';
import { mapActions } from 'vuex';
import { classStatus } from '@/shared/global-status';
import { EXPENSE_TREE_NAME } from '@/shared/constants';

export default {
	name: 'RejectExpenseItemModal',
	mixins: [LanguageMessages, GlobalMixin, validationMixin],
	computed: {
		isOpen: {
			get: function () {
				return this.value;
			},
			set: function (value) {
				return value;
			}
		},
		title() {
			let title = '';
			switch (this.typeName) {
				case EXPENSE_TREE_NAME.CHILDREN:
					title = this.FormMSG(1, 'Refuse this expense item');
					break;
				case EXPENSE_TREE_NAME.PARENT:
					title = this.FormMSG(6, 'Refuse this expense');
					break;
			}

			return title;
		}
	},
	props: {
		value: {
			type: Boolean,
			required: false,
			default: false
		},
		id: {
			type: [Number, String],
			required: true,
			default: 0
		},
		index: {
			type: Number,
			required: false,
			default: 0
		},
		typeName: {
			type: String,
			required: true,
			default: EXPENSE_TREE_NAME.CHILDREN
		}
	},
	data() {
		return {
			watingSubmitForm: false,
			comment: ''
		};
	},
	mounted() {
		this.$v.$touch();
	},
	methods: {
		...mapActions({
			getNotifications: 'header/getNotifications'
		}),
		emitEventClose() {
			this.comment = '';
			this.$emit('reject-expense-item-modal:close');
		},
		async save() {
			this.watingSubmitForm = true;
			switch (this.typeName) {
				case EXPENSE_TREE_NAME.CHILDREN:
					await rejectExpenseItem(+this.id, this.comment)
						.then(async (record) => {
							await this.getNotifications();
							this.comment = '';
							record.comment = record.comment;
							record.validatedStatus = this.validatedText(record.validated);
							record.statusClass = classStatus(record.validated);
							this.$emit('reject-expense-item-modal:rejected', record);
							this.watingSubmitForm = false;
						})
						.catch((error) => {
							this.comment = '';
							console.log(error);
							this.watingSubmitForm = false;
						});

					break;
				case EXPENSE_TREE_NAME.PARENT:
					await rejectExpense(+this.id, this.comment)
						.then(async (record) => {
							await this.getNotifications();
							this.emitEventClose();
							this.$emit('reject-expense-item-modal:redirectAndReloadExpenseDatatable', record);
							this.watingSubmitForm = false;
						})
						.catch((error) => {
							this.comment = '';
							console.log(error);
							this.watingSubmitForm = false;
						});
					break;
			}
		},
		validatedText(validated) {
			return this.GetTextFromMenuNumberAndMenuValue(1008, validated);
		},
		focusedOnComment() {
			this.$refs.comment.focus();
		}
	},
	validations() {
		return {
			comment: {
				required,
				min: minLength(3)
			}
		};
	}
};
</script>
